/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from 'react';
import {
  useApi,
  identityApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import { getLocalToken } from '../../utils/localDevUtils';

export const useUserProfile = () => {
  const [headerToken, setHeaderToken] = useState<any>('');
  const [accessToken, setAccessToken] = useState<any>('');
  const [profileName, setProfName] = useState<any>('');
  const [profEmail, setProfEmail] = useState<any>('');
  const [profile, setProfile] = useState<any>();
  const [displayName, setDisplayName] = useState<any>();
  const [userId, setUserId] = useState<any>();

  const identityApi = useApi(identityApiRef);
  const msAuthApi = useApi(microsoftAuthApiRef);

  const fetchProfile = async () => {
    const userProf = await identityApi.getProfileInfo();
    let disName = userProf.displayName;
    let Email = userProf.email;

    // Fallback for new auth flow where profile info can be minimal on first load.
    if (!Email || !disName) {
      try {
        const identity = await identityApi.getBackstageIdentity();
        const entityRef = identity?.userEntityRef || '';
        const userPart = entityRef.includes('/')
          ? entityRef.split('/').pop() || ''
          : '';
        if (!Email && userPart.includes('@')) Email = userPart;
        if (!disName) disName = userPart || entityRef;
      } catch {
        // Ignore fallback errors and keep existing values.
      }
    }

    setProfName(disName);
    setProfEmail(Email);
    return { ...userProf, displayName: disName, email: Email };
  };

  const fetchUser = async () => {
    const userIx = await identityApi.getBackstageIdentity();
    const entityRef = userIx.userEntityRef;
    return entityRef;
  };

  const fetchProfileInfo = async () => {
    const userProf = await identityApi.getProfileInfo(); // TODO: investigate the app and find the need for this
    return userProf;
  };

  const populateUserProfile = useCallback(async () => {
    try {
      const profileFromIdentity = await fetchProfile();
      const userId = await fetchUser();
      setUserId(userId);

      const profile = await fetchProfileInfo();
      setProfile(profile || profileFromIdentity);

      const resolvedDisplayName =
        profileFromIdentity?.displayName || profileName || userId;
      setDisplayName(resolvedDisplayName);

      const tokenResp = await identityApi.getCredentials();
      setHeaderToken(tokenResp.token);

      // Keep headerToken as Backstage identity token, but use Microsoft token
      // for downstream discovery/service APIs.
      let resolvedAccessToken = '';
      try {
        resolvedAccessToken =
          (await msAuthApi.getAccessToken(undefined, {
            optional: true,
          })) || '';
      } catch {
        resolvedAccessToken = '';
      }

      if (!resolvedAccessToken) {
        resolvedAccessToken =
          getLocalToken('devx_ms_token') || getLocalToken('msToken') || '';
      }

      // Final fallback keeps existing behavior in environments where MS token
      // cannot be retrieved (for example, incomplete auth setup).
      if (!resolvedAccessToken) {
        resolvedAccessToken = tokenResp.token || '';
      }

      setAccessToken(resolvedAccessToken || '');
    } catch {
      setAccessToken('');
    }
  }, []);

  useEffect(() => {
    populateUserProfile();
  }, [profileName, identityApi]);

  return {
    headerToken,
    profile,
    displayName,
    accessToken,
    profEmail,
    profileName,
    userId,
    refreshProfileAndAuth: populateUserProfile,
  };
};
